
export class ButtonWithIconObject {
  value?: number | string;
  name: string;
  icon?: string;
  badge?: string;
  disable?:boolean;
  disabled?:boolean;
  donemKontrolYn?: boolean;
}

export interface DynamicButton {
  name?:string;
  text?: string;
  style?:any;
  hint?:string,
  icon?: string;
  type?: any;
  width?: any;
  stylingMode?: any;
  disabled?: boolean;
  donemKontrolYn?: boolean;
  clickHandler?: () => void;
}

export interface DonemKontrolObject {
  donemKontrolDate?:Date;
  kontrolDataField?: string;
}
